import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ModalProps } from "types/utils/modal";

export const RAndDNoteModal = ({ isOpen, close }: ModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <StatusModal
        type="warning"
        title="A quick note before you proceed"
        showCloseButton={false}
      >
        <div className="t-text-body-sm t-text-text-30">
          All communication and payments for Form 6765 happen directly between
          you and ADP. Inkle connects your R&D credit to your 1120 filing once
          it&apos;s ready.
        </div>
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Button customType="primary" onClick={() => close()}>
          Got it, continue
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
